import React, { useEffect, useState } from "react";
import Filter from "../../../../assets/Icons/filter.png";
import ExcelExport from "../../../../compnenets/commons/xls";
import Modal from "react-responsive-modal";
import Close from "../../../../assets/Images/close.png";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../archival.css";
import { PROJECT_ARCHIVAL } from "../../../../services/apiCalls/archivalApiCalls";

export default function WorkPermit({ project }) {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const [workPermitData, setWorkPermitData] = useState([]);
  const [filterData, setFilterData] = useState({
    ProjectID: project.project_id,
    OriginPermitValidFromDate: "",
    OriginPermitValidToDate: "",
    ContractorPartnerName_EmailID: "",
    TypeOfJobBeingPerformed: "",
    sortOrder: "ASC",
    sortBy: "Site Vist/Audit Date",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(workPermitData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = workPermitData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const fetchArchivalWorkPermit = async (payload) => {
    let obj = payload;
    if (!payload) {
      obj = {
        ProjectID: project.project_id,
      };
    }
    const response = await PROJECT_ARCHIVAL.Get_WorkPermit(obj);
    if (response && response.WorkPermitList?.length > 0) {
      setWorkPermitData(response.WorkPermitList);
    } else {
      setWorkPermitData([]);
    }
  };
  useEffect(() => {
    fetchArchivalWorkPermit();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <React.Fragment>
      <Modal open={open} onClose={() => {}} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resources">Work Permit Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpen(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">
                    Origin permit from date
                  </label>
                  <input
                    type="date"
                    name="OriginPermitValidFromDate"
                    value={filterData.OriginPermitValidFromDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Origin permit to date</label>
                  <input
                    type="date"
                    name="OriginPermitValidToDate"
                    value={filterData.OriginPermitValidToDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Contractor Name</label>
                  <input
                    type="text"
                    value={filterData?.ContractorPartnerName_EmailID}
                    name="ContractorPartnerName_EmailID"
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">
                    Type of job being performed
                  </label>
                  <select
                    onChange={handleChange}
                    value={filterData?.TypeOfJobBeingPerformed}
                    name="TypeOfJobBeingPerformed"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                      color: "gray",
                      fontSize: 13,
                      paddingLeft: 10,
                    }}
                  >
                    <option value={""}>--Select--</option>
                    <option value={"Category 1"}>Category 1</option>
                    <option value={"Category 2"}>Category 2</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Work Permit</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                name="sortOrder"
                value={filterData.sortOrder}
                onChange={handleChange}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="ASC">ASC</option>
                <option value="DES">DES</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: 20 }}>
          {["Origin permit from date", "Origin permit to date"].map(
            (sortOption) => (
              <div className="form-check" key={sortOption}>
                <input
                  className="form-check-input shadow-none"
                  type="radio"
                  name="sortBy"
                  id={sortOption}
                  value={sortOption}
                  checked={filterData.sortBy === sortOption}
                  onChange={handleChange}
                />
                <label htmlFor={sortOption} style={{ fontSize: 14 }}>
                  {sortOption}
                </label>
              </div>
            )
          )}
        </div>

        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => {
              fetchArchivalWorkPermit(filterData);
              setCurrentPage(1);
              setOpen(false);
            }}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div className="row">
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport
              data={workPermitData}
              fileName="Workpermit"
              sheet="Workpermit List"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpen(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto" onClick={() => fetchArchivalWorkPermit()}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container-archival">
        <table id="custom-table-archival">
          <thead className="table-header-archival">
            <tr>
              <th>Sr No</th>
              <th>Project ID</th>
              <th>Project Name</th>
              <th>Region</th>
              <th>Site Location</th>
              <th title="Origin Permit Valid From Date">Origin Permit...</th>
              <th title="Origin Permit Valid To Date">Origin Permit...</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index} onClick={onOpenModal}>
                <td>{index + 1 + (currentPage - 1) * 10}</td>
                <td>{row.ProjectID}</td>
                <td>{row.ProjectName}</td>
                <td>{row.Region}</td>
                <td>{row.SiteLocation}</td>
                <td>{new Date(row?.OriginPermitValidFromDate).toLocaleDateString('en-GB')}</td>
                <td>{new Date(row?.OriginPermitValidToDate).toLocaleDateString('en-GB')}</td>
                <td>{new Date(row?.CreatedOn).toLocaleDateString('en-GB')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
        }}
      >
        <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
          Showing{" "}
          {Math.min((currentPage - 1) * rowsPerPage + 1, workPermitData.length)}{" "}
          to {Math.min(currentPage * rowsPerPage, workPermitData.length)} of{" "}
          {workPermitData.length} entries
        </div>

        <div
          className="pagination-buttons"
          style={{
            fontSize: "14px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "5px",
          }}
        >
          {/* Left Arrow */}
          <button
            onClick={() => handleClick(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={leftArrow} // Replace with your actual image path
              alt="Previous"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
            />
          </button>

          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handleClick(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#00B69B" : "transparent",
                color: currentPage === i + 1 ? "#fff" : "#000",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          {/* Right Arrow */}
          <button
            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={rightArrow} // Replace with your actual image path
              alt="Next"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
            />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
